import type { CollectionGridItem } from "./collection-grid-item";
import type { CollectionSort } from "./collection-grid-options";
import { compareCollectionText } from "./compare-collection-text";

export function compareCollectionItems(
  left: CollectionGridItem,
  right: CollectionGridItem,
  sort: CollectionSort,
  collator: Intl.Collator,
): number {
  const fallback = left.originalIndex - right.originalIndex;
  switch (sort) {
    case "rankingAsc":
      return fallback;
    case "rankingDesc":
      return -fallback;
    case "titleAsc":
      return compareCollectionText(left.entity.title, right.entity.title, collator, 1) || fallback;
    case "titleDesc":
      return compareCollectionText(left.entity.title, right.entity.title, collator, -1) || fallback;
    case "artistAsc":
      return (
        compareCollectionText(left.entity.subtitle, right.entity.subtitle, collator, 1) || fallback
      );
    case "artistDesc":
      return (
        compareCollectionText(left.entity.subtitle, right.entity.subtitle, collator, -1) || fallback
      );
  }
}
